import { BaseCard } from '@nebula/cards';
import { BodyLarge400, BodyMedium400, TitleMedium500, TitleSmall500 } from '@nebula/global-styles';
import { TextLink } from '@nebula/text-link';
import styled from 'styled-components';

export const CurrentAndChosenDateCard = styled(BaseCard)`
  align-items: center;
  padding: 12px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 16px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding: 24px;
  }
`;

export const CardSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  border-left: ${props => (props.withBorder ? `1px solid ${props.theme.color.ui.grey[20]}` : 'none')};
`;

export const DateContainer = styled.div`
  margin-left: ${props => (props.withMargin ? '20px' : 'none')};
  > ${BodyMedium400} {
    color: ${({ theme }) => theme.color.ui.grey[80]};
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${BodyLarge400} {
    color: ${({ theme }) => theme.color.ui.grey[80]};
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${TitleMedium500} {
    margin-top: 8px;
    margin-bottom: 4px;
  }
  > ${TitleSmall500} {
    margin-top: 8px;
    margin-bottom: 4px;
  }

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin-left: ${props => (props.withMargin ? '40px' : 'none')};
  }
`;

export const EditLink = styled(TextLink)`
  font-size: 14px;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
  }
`;
